import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import ProductCard, { Product } from './ProductCard';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

interface ProductCardSliderProps {
  products: Product[];
}

const ProductSlider: React.FC<ProductCardSliderProps> = ({ products }) => {
  return (
    <div className="product-card-slider-container">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={0}
        slidesPerView="auto" // Adjust based on screen size in breakpoints
        loop={true}
        navigation
        pagination={{ clickable: true }}
        autoplay={{
          delay: 100000,
          disableOnInteraction: false,
        }}
        breakpoints={{
          0: {
            slidesPerView: 1.1, // Show 1 fully and a bit of the next
          },
          200: {
            slidesPerView: 1.2, // Show 1 fully and a bit of the next
          },
          400: {
            slidesPerView: 1.5,
          },
          500: {
            slidesPerView: 1.7,
          },
          560: {
            slidesPerView: 2,
          },
          600: {
            slidesPerView: 2.3,
          },
          700: {
            slidesPerView: 2.6,
          },
          760: {
            slidesPerView: 2.8,
          },
          767: {
            slidesPerView: 2.2,
          },
          800: {
            slidesPerView: 2.3,
          },
          860: {
            slidesPerView: 2.5,
          },
          900: {
            slidesPerView: 2.8,
          },
          960: {
            slidesPerView: 3,
          },
          1000: {
            slidesPerView: 3.3,
          },
          1060: {
            slidesPerView: 3.5,
          },
          1100: {
            slidesPerView: 4,
          }
        }}
        className="product-card-swiper"
      >
        {products.map((product) => (
          <SwiperSlide key={product.id}>
            <ProductCard product={product} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default ProductSlider;